import { render, staticRenderFns } from "./emailNotification-form.vue?vue&type=template&id=17d5b2e2&"
import script from "./emailNotification-form.vue?vue&type=script&lang=js&"
export * from "./emailNotification-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports